import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import ReactModal, { Props as ReactModalProps } from 'react-modal';
import { Container } from './layout';

const VideoModalClose = styled.div`
  position: absolute;
  top: 10px;
  right: 15px;
  padding: 10px;
  font-size: 32px;
  color: #e54500;
  cursor: pointer;
  svg {
    width: 27px;
    height: 27px;
  }
  &:hover {
    opacity: 0.8;
  }
`;

const VideoWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  overflow: hidden;
  background: rgb(255, 255, 255);
  border-radius: 24px;
  overflow: hidden;
  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const VideoModalContentStyled = styled(ReactModal)`
  width: 100%;
  display: inline-block;
  vertical-align: middle;
  &:focus {
    outline: 0;
  }
`;

const VideoModalStyled = styled(({ className, ...rest }: ReactModalProps & { children: React.ReactNode }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <VideoModalContentStyled overlayClassName={className} {...rest} />
))`
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(59, 58, 108, 0.8);
  height: 100%;
  width: 100%;
  z-index: 100;
  overflow: auto;
  padding: 80px 0 80px;
  font-size: 0;
  &:before {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }
  &:focus {
    outline: 0;
  }
`;

const VideoModalBackgroundBlur = createGlobalStyle`
  .ReactModal__Body--open #app-render-root {
    filter: blur(4px);
  }
`;

const VideoModal = ({ isOpen, onClose, videoSrc }: { isOpen: boolean; onClose: () => void; videoSrc: string }) => (
  <VideoModalStyled isOpen={isOpen} onRequestClose={onClose}>
    <VideoModalBackgroundBlur />
    <VideoModalClose onClick={onClose} onKeyPress={onClose} role="button" tabIndex={0}>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.41425 6.00025L11.7072 1.70725C12.0982 1.31625 12.0982 0.68425 11.7072 0.29325C11.3162 -0.09775 10.6843 -0.09775 10.2933 0.29325L6.00025 4.58625L1.70725 0.29325C1.31625 -0.09775 0.68425 -0.09775 0.29325 0.29325C-0.09775 0.68425 -0.09775 1.31625 0.29325 1.70725L4.58625 6.00025L0.29325 10.2933C-0.09775 10.6843 -0.09775 11.3162 0.29325 11.7072C0.48825 11.9022 0.74425 12.0002 1.00025 12.0002C1.25625 12.0002 1.51225 11.9022 1.70725 11.7072L6.00025 7.41425L10.2933 11.7072C10.4883 11.9022 10.7442 12.0002 11.0002 12.0002C11.2562 12.0002 11.5122 11.9022 11.7072 11.7072C12.0982 11.3162 12.0982 10.6843 11.7072 10.2933L7.41425 6.00025Z"
          fill="#FFFFFF"
        />
      </svg>
    </VideoModalClose>
    <Container>
      <VideoWrapper>
        <iframe
          title="Demo video"
          width="560"
          height="315"
          src={videoSrc}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </VideoWrapper>
    </Container>
  </VideoModalStyled>
);

export default VideoModal;
